// extracted by mini-css-extract-plugin
export default {"container":"Paragraph_container__a3Nzv","text":"Paragraph_text__0pw+I","para":"Paragraph_para__1gsi4"};